module.exports = __webpack_public_path__ + "assets/img/xby.15ebb040.jpg";